const keyMappings = {
  'ARROW LEFT/RIGHT KEY': [['left'], ['right']],
  'CTR ARROW LEFT/RIGHT KEY': [['ctrl+left'], ['ctrl+right']],
  'ALT ARROW UP/DOWN KEY': [['alt+up'], ['alt+down']],
  'ARROW UP/DOWN KEY': [['up'], ['down']],
  'ARROW UP/DOWN KEY AND ARROW LEFT/RIGHT KEY': [['up'], ['down'], ['left'], ['right']],
  'PAGE UP/DOWN KEY': [['pageup'], ['pagedown']],
  'CTR ARROW UP/DOWN KEY': [['ctrl+up'], ['ctrl+down']],
  'COPY IMAGE': [['ctrl+c']],
};

const actionMappings = {
  'Image Navigation': {
    commandName: 'nextImage',
    commandOptions: {},
    label: 'Image Navigation',
  },
  'Study Navigation': {
    commandName: 'updateViewportDisplaySet',
    commandOptions: { direction: 1 },
    label: 'Next Series',
  },
  'Current Series Navigation': {
    commandName: 'updateViewportDisplaySet',
    commandOptions: { direction: -1 },
    label: 'Previous Series',
  },
  'All Series Navigation': {
    commandName: 'nextImage',
    commandOptions: {},
    label: 'All Series Navigation',
  },
  Zoom: {
    commandName: 'setToolActive',
    commandOptions: { toolName: 'Zoom' },
    label: 'Zoom',
  
  },
  'Copy Image': {
    commandName: 'copyImgToClipboard',
    commandOptions: {},
    label: 'Copy Image',
  }
};

function getDefinitionKey(definition) {
  const { commandName, commandOptions = {} } = definition || {};

  return JSON.stringify({
    commandName,
    commandOptions,
  });
}

export function mapApiResponseToHotkeys(items = []) {
  if (!Array.isArray(items)) {
    console.warn('mapApiResponseToHotkeys: items is not an array, skipping');
    return [];
  }

  const results = [];

  items.forEach(item => {
    const { mkShortcutKey, mkShortcutAction, mkIsActive } = item || {};

    if (!mkIsActive) {
      return;
    }

    const keyMapping = keyMappings[mkShortcutKey];
    if (!keyMapping) {
      console.warn('mapApiResponseToHotkeys: unknown mkShortcutKey, skipping', mkShortcutKey);
      return;
    }

    const actionMapping = actionMappings[mkShortcutAction];
    if (!actionMapping) {
      console.warn(
        'mapApiResponseToHotkeys: unknown mkShortcutAction, skipping',
        mkShortcutAction
      );
      return;
    }

    keyMapping.forEach(keysArray => {
      results.push({
        commandName: actionMapping.commandName,
        commandOptions: actionMapping.commandOptions,
        keys: keysArray,
        label: actionMapping.label,
        isEditable: true,
      });
    });
  });

  return results;
}

export function mergeWithDefaults(defaultHotkeys = [], apiHotkeys = []) {
  const defaultsArray = Array.isArray(defaultHotkeys) ? defaultHotkeys : [];
  const apiArray = Array.isArray(apiHotkeys) ? apiHotkeys : [];

  if (!defaultsArray.length && !apiArray.length) {
    return [];
  }

  const apiKeys = new Set(apiArray.map(getDefinitionKey));

  const merged = [
    ...defaultsArray.filter(def => !apiKeys.has(getDefinitionKey(def))),
    ...apiArray,
  ];

  return merged;
}

